// ============================================
// LIGA AJUPAM - Ventana del CTA del reglamento (v6.11.68)
// ============================================
// ¿Estamos dentro de los primeros 5 días con la app entera habilitada para esta
// persona? El cálculo puro (y su manejo de timezone y de la inscripción tardía)
// vive en utils/rulebookCtaWindow.
//
// Mismo patrón que useFirstCompetitionWeek: "ahora" congelado en estado para que
// el render sea puro, y refrescado cuando la app vuelve del segundo plano — que
// es justo cuando pudo haber cruzado la medianoche y vencido la ventana sin que
// la pestaña se enterara.

import { useMemo, useState } from 'react';
import {
  computeRulebookCtaWindow,
  type RulebookCtaWindow,
  type RulebookCtaWindowInput,
} from '../utils/rulebookCtaWindow';
import { useAppResume } from './useAppResume';

export type { RulebookCtaWindow };

export function useRulebookCtaWindow(
  input: Omit<RulebookCtaWindowInput, 'nowMs'>
): RulebookCtaWindow {
  const [now, setNow] = useState(() => Date.now());
  useAppResume(() => setNow(Date.now()), { throttleMs: 60_000 });

  const {
    regularPhaseStartDate, teamCreatedAt, seasonSectionsLocked, dataLoaded,
    ctaEnabled, ctaStartDate, ctaEndDate,
  } = input;

  return useMemo(
    () => computeRulebookCtaWindow({
      regularPhaseStartDate,
      teamCreatedAt,
      seasonSectionsLocked,
      dataLoaded,
      ctaEnabled,
      ctaStartDate,
      ctaEndDate,
      nowMs: now,
    }),
    [regularPhaseStartDate, teamCreatedAt, seasonSectionsLocked, dataLoaded,
     ctaEnabled, ctaStartDate, ctaEndDate, now],
  );
}
